import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={8} height={8} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_7992_188520)">
      <path
        d="M4 7.5C5.933 7.5 7.5 5.933 7.5 4C7.5 2.067 5.933 0.5 4 0.5C2.067 0.5 0.5 2.067 0.5 4C0.5 5.933 2.067 7.5 4 7.5Z"
        fill="#070F21"
        stroke="#070F21"
      />
      <circle cx="4" cy="2.25" r="0.5" fill="white" />
      <rect x="3.5" y="3.5" width="1" height="2.75" rx="0.5" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_7992_188520">
        <rect width="8" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const InformationIcon = memo(ForwardRef);
export default InformationIcon;
